import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveW8BenFormMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveW8BENFormParam } from 'api/types/params';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveW8BENForm = () => {
  const [saveW8BenForm, { data, loading, error: apolloError }] =
    useLegalClientSaveW8BenFormMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveW8BENForm
      ? parseLegalClient(data.legalClientSaveW8BENForm)
      : undefined,
    loading,
    error,
    saveW8BenForm: useCallback(
      async (id: string, params: SaveW8BENFormParam) => {
        const res = await saveW8BenForm({
          variables: { id, input: params },
        });
        return res.data?.legalClientSaveW8BENForm
          ? parseLegalClient(res.data.legalClientSaveW8BENForm)
          : undefined;
      },
      [saveW8BenForm]
    ),
  };
};
